<script setup lang="ts">
import { PropType } from "vue";
import { TranslatedProduct } from "../../../types/PersologOnlineTypes";
import { useI18n } from "vue-i18n";
import EditableBenchmarkDiagram from "../job-match/EditableBenchmarkDiagram.vue";

// Define props
const props = defineProps({
    product: {
        type: Object as PropType<TranslatedProduct>,
        default: null,
    },
    language: {
        type: String,
        required: true,
    },
    dominantRange: {
        type: Array as PropType<number[]>,
        default: () => [12.5, 87.5],
    },
    initiativeRange: {
        type: Array as PropType<number[]>,
        default: () => [12.5, 87.5],
    },
    steadyRange: {
        type: Array as PropType<number[]>,
        default: () => [12.5, 87.5],
    },
    cautiousRange: {
        type: Array as PropType<number[]>,
        default: () => [12.5, 87.5],
    },
});

// Use i18n
const { t } = useI18n();

// Define emits
const emit = defineEmits(["valid", "update:range-values"]);

function updateRangeValues(rangeValues: Array<number[]>) {
    emit("update:range-values", rangeValues);
}

const validate = () => {
    emit("valid", true);
    return true;
};
defineExpose({ validate });
</script>

<template>
    <div class="card flex-row step-content">
        <h2 v-if="props.product">{{ props.product.productName }}</h2>
        <h3>{{ t("project-configuration.jobMatch.diagram.description") }}</h3>
        <p>{{ t("project-configuration.jobMatch.diagram.instructions") }}</p>
        <EditableBenchmarkDiagram
            :dominant-range="props.dominantRange"
            :initiative-range="props.initiativeRange"
            :steady-range="props.steadyRange"
            :cautious-range="props.cautiousRange"
            :language="props.language"
            @update:range-values="updateRangeValues"
        ></EditableBenchmarkDiagram>
    </div>
</template>

<style scoped>
/* CSS */
</style>
